import React from 'react';
import { FieldSelect } from './FieldSelect';
import { FieldDatePicker } from './FieldDatePicker';
import FormRow from './row';
import {
  ethnicityList,
  genderList,
  pronounsList,
  // regionList,
} from './constants';
import FieldCheckbox from './FieldCheckbox';

export default function FormDemographics() {
  return (
    <>
      <FormRow count={2}>
        <FieldSelect name="gender" options={genderList} />
        <FieldSelect name="pronouns" options={pronounsList} />
      </FormRow>

      <FormRow count={2}>
        <FieldSelect name="ethnicity" options={ethnicityList} />
      </FormRow>

      <FieldCheckbox text="Parent" name="isParent" />

      <FormRow count={2}>
        <FieldDatePicker name="dateOfBirth" label="Date of Birth" />
        {/* Commenting out Region Demographics field for all roles */}
        {/* <FieldSelect name="region" options={regionList} /> */}
      </FormRow>
    </>
  );
}
